import React, { useEffect, useState } from 'react';
import { FiImage } from 'react-icons/fi';
import DisplayProductImage from './DisplayProductImage';
import { displayPrice, displayPromotionLabels, formatDisplayPrice } from './branchDisplayUtils';

export const displayEditorItemTitle = (item) => [item.productName, item.varietyName, item.formatLabel || item.metricUnit].filter(Boolean).join(' · ');
export const displayEditorPriceLabel = (item, now, showPromotions = true) => item.regularPrice == null || item.regularPrice === '' ? 'Sin precio'
  : `${formatDisplayPrice(displayPrice(item, now, showPromotions).effectivePrice)}${item.metricUnit ? ` / ${item.metricUnit}` : ''}`;

export const DisplayEditorPromotionLabels = ({ item, now, showPromotions = true }) => {
  const labels = displayPromotionLabels(item, now, showPromotions);
  return labels.length > 0 ? <span className="display-promotion-labels" aria-label="Ofertas y promociones vigentes">{labels.map((label) => <span key={label}>{label}</span>)}</span> : null;
};

export const DisplayEditorItemImage = ({ item }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [item.imageUrl]);
  return <span className="display-editor-thumbnail">
    {item.imageUrl && !failed ? <DisplayProductImage imageUrl={item.imageUrl} onError={() => setFailed(true)} /> : <FiImage aria-hidden="true" />}
  </span>;
};
